export default "__VITE_ASSET__BeCKp_1c__"